import { Controller } from '@hotwired/stimulus'

// Live countdown for promo codes (starts-in / expires-in).
export default class extends Controller {
  static targets = ['display', 'status']

  static values = {
    startsAt: String,
    expiresAt: String,
    active: { type: Boolean, default: true },
    usedUp: { type: Boolean, default: false }
  }

  connect () {
    this.tick()
    this.timer = window.setInterval(() => this.tick(), 1000)
  }

  disconnect () {
    if (this.timer) window.clearInterval(this.timer)
  }

  tick () {
    const now = Date.now()
    const startsAt = this.parse(this.startsAtValue)
    const expiresAt = this.parse(this.expiresAtValue)

    if (!this.activeValue) {
      this.render('Inactive', 'Inactive', 'slate')
      return
    }

    if (this.usedUpValue) {
      this.render('Used up', 'Used up', 'slate')
      return
    }

    if (startsAt && startsAt > now) {
      this.render(`Starts in ${this.format(startsAt - now)}`, 'Scheduled', 'amber')
      return
    }

    if (expiresAt && expiresAt <= now) {
      this.render('Expired', 'Expired', 'rose')
      return
    }

    if (expiresAt) {
      this.render(`Ends in ${this.format(expiresAt - now)}`, 'Live', 'emerald')
      return
    }

    this.render('No end date', 'Live', 'emerald')
  }

  parse (value) {
    if (!value) return null
    const ms = Date.parse(value)
    return Number.isNaN(ms) ? null : ms
  }

  format (ms) {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000))
    const days = Math.floor(totalSeconds / 86400)
    const hours = Math.floor((totalSeconds % 86400) / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    const parts = []
    if (days > 0) parts.push(`${days}d`)
    if (hours > 0 || days > 0) parts.push(`${hours}h`)
    parts.push(`${minutes}m`)
    parts.push(`${String(seconds).padStart(2, '0')}s`)
    return parts.join(' ')
  }

  render (timerText, statusText, tone) {
    if (this.hasDisplayTarget) this.displayTarget.textContent = timerText
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = statusText
      this.statusTarget.className = this.badgeClass(tone)
    }
  }

  badgeClass (tone) {
    const tones = {
      emerald: 'rounded-full bg-emerald-100 px-2.5 py-1 text-xs font-bold text-emerald-800',
      amber: 'rounded-full bg-amber-100 px-2.5 py-1 text-xs font-bold text-amber-900',
      rose: 'rounded-full bg-rose-100 px-2.5 py-1 text-xs font-bold text-rose-800',
      slate: 'rounded-full bg-slate-100 px-2.5 py-1 text-xs font-bold text-slate-700'
    }
    return tones[tone] || tones.slate
  }
}
